import styles from './LegalPage.module.css';

const HipaaPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>HIPAA Notice of Privacy Practices</h1>
        <p className={styles.lastUpdated}>Effective Date: November 3, 2025</p>

        <section>
          <p className={styles.importantNotice}>
            <strong>THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION. PLEASE REVIEW IT CAREFULLY.</strong>
          </p>
          <p>
            When this Notice of Privacy Practices ("Notice") refers to "we", "us", or "our", it refers to Oval Care, Inc., and all affiliated healthcare professionals and employees involved in providing or coordinating your care. We are required by federal law (HIPAA) to maintain the privacy of your protected health information ("PHI"), to provide this Notice describing our legal duties and privacy practices, and to notify you in the event of a breach of unsecured PHI. We reserve the right to update or amend this Notice. When updated, the revised version will be posted on our website and available upon request.
          </p>
        </section>

        <section>
          <h2>I. How We May Use and Disclose Your PHI</h2>
          <p>
            We may use and disclose your PHI for the purposes of treatment, payment, and healthcare operations, and for other purposes permitted or required by law. Any other uses will only occur with your written authorization, which you may revoke in writing at any time.
          </p>

          <h3>A. Treatment</h3>
          <p>
            We may use and disclose your PHI to provide you with healthcare services, prescriptions, and follow-up care. This may include sharing information with other healthcare professionals involved in your treatment.
          </p>

          <h3>B. Payment</h3>
          <p>
            We may use and disclose your PHI to obtain payment for the services we provide, such as submitting claims, obtaining prior authorizations, or verifying insurance coverage.
          </p>

          <h3>C. Healthcare Operations</h3>
          <p>
            We may use and disclose your PHI for our internal business activities, such as quality improvement, audits, accreditation, training, and compliance monitoring.
          </p>

          <h3>D. Refill Reminders and Health-Related Benefits</h3>
          <p>
            We may use your PHI to contact you with prescription reminders, information about treatment alternatives, or health-related products and services that may be beneficial to you.
          </p>

          <h3>E. Family Members or Caregivers</h3>
          <p>
            Unless you object, we may disclose relevant portions of your PHI to family members, caregivers, or others involved in your care or payment.
          </p>

          <h3>F. Other Uses and Disclosures Permitted or Required by Law</h3>
          <ul>
            <li>To public health authorities for disease prevention, reporting adverse events, or notifying of communicable diseases;</li>
            <li>To health oversight agencies for audits, inspections, or investigations;</li>
            <li>For judicial or administrative proceedings, in response to court orders or subpoenas;</li>
            <li>To law enforcement when required by law or to report crimes;</li>
            <li>To coroners, medical examiners, or funeral directors as necessary for their duties;</li>
            <li>For organ or tissue donation and transplantation purposes;</li>
            <li>For research approved under applicable HIPAA standards;</li>
            <li>To avert a serious threat to health or safety;</li>
            <li>For military, national security, or intelligence purposes;</li>
            <li>To comply with workers' compensation or similar laws.</li>
          </ul>
        </section>

        <section>
          <h2>II. Your Rights Regarding Your PHI</h2>
          <p>As our patient, you have the following rights:</p>

          <h3>A. Right to Request Restrictions</h3>
          <p>
            You may request restrictions on how we use or disclose your PHI. While we are not required to agree, if we do, we will comply except as required by law or in emergencies.
          </p>

          <h3>B. Right to Confidential Communications</h3>
          <p>
            You may request that we communicate with you through alternative means or locations (e.g., mailing prescriptions to a different address). We will accommodate reasonable requests.
          </p>

          <h3>C. Right to Access and Copies</h3>
          <p>
            You may request to access or obtain a copy of your PHI, including electronic copies. We may charge a reasonable fee for copies and mailing. Certain legal exceptions may apply to what can be released.
          </p>

          <h3>D. Right to an Accounting of Disclosures</h3>
          <p>
            You may request an accounting of disclosures of your PHI made during the past six (6) years, except for disclosures related to treatment, payment, or healthcare operations. The first request each year is free; additional requests may incur a reasonable fee.
          </p>

          <h3>E. Right to Request Amendments</h3>
          <p>
            If you believe your PHI is incorrect or incomplete, you may request an amendment. We will respond in writing and may deny your request if the information is accurate or not created by us. If denied, you may submit a written statement of disagreement.
          </p>

          <h3>F. Right to a Paper Copy</h3>
          <p>
            You may obtain a paper copy of this Notice at any time, even if you previously received it electronically.
          </p>

          <h3>G. Right to Opt Out of Marketing or Sale of PHI</h3>
          <p>
            Your PHI will not be sold or used for fundraising without your written authorization.
          </p>
        </section>

        <section>
          <h2>III. Questions, Complaints, or Additional Information</h2>
          <p>
            If you have questions about this Notice, wish to exercise your rights, or believe your privacy rights have been violated, please contact our Privacy Officer at:
          </p>
          <address>
            Oval Care, Inc.<br />
            Attn: Patient Care Team<br />
            848 Brickell Avenue PH5,<br />
            Miami, FL 33131<br />
            United States<br />
            Phone: +1 (737) 396‑1791<br />
            Email: <a href="mailto:support@ovalcare.com">support@ovalcare.com</a>
          </address>
          <p>
            You may also file a complaint directly with the Secretary of the U.S. Department of Health and Human Services:
          </p>
          <address>
            U.S. Department of Health and Human Services<br />
            200 Independence Avenue SW<br />
            Washington, D.C. 20201<br />
            Phone: (877) 696‑6775
          </address>
          <p>
            <strong>We will not retaliate against you for filing a complaint.</strong>
          </p>
        </section>
      </div>
    </div>
  );
};

export default HipaaPage;
